"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PrivacyIcon = void 0;
var _core = require("@material-ui/core");
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var PrivacyIcon = function PrivacyIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_core.SvgIcon, _extends({}, props, {
    viewBox: "0 0 24 24"
  }), /*#__PURE__*/_react.default.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clip0_5549_299524)"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "24",
    height: "24",
    rx: "12",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    width: "24",
    height: "24",
    rx: "12",
    fill: "#13131C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 4.65625L18 7.34375V11.3438C18 13.1979 17.4271 14.8958 16.2812 16.4375C15.1354 17.9583 13.7083 18.9271 12 19.3438C10.2917 18.9271 8.86458 17.9583 7.71875 16.4375C6.57292 14.8958 6 13.1979 6 11.3438V7.34375L12 4.65625ZM12 12V17.9688C13.2292 17.5729 14.2708 16.8333 15.125 15.75C15.9792 14.6458 16.4896 13.3958 16.6562 12H12ZM12 12V6.125L7.34375 8.1875V12H12Z",
    fill: "white"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip0_5549_299524"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "24",
    height: "24",
    rx: "12",
    fill: "white"
  })))));
};
exports.PrivacyIcon = PrivacyIcon;